import Dropdown from '@theme/components/utils/Dropdown'
import LoginForm from '@theme/components/user/LoginForm'

export default {
  components: {
    Dropdown,
    LoginForm,
  },
}
